import { BaseCart, CartItem, CartItemQuery } from '@eastsideco/salvo-ts';

export default class Cart extends BaseCart

{
    constructor() {
        super();
    }

    isEmpty() {
        return cart.items.length <= 0;
    }

    getCartItemCount() {
        let itemCount = 0;
        for (const item of cart.items) {
            itemCount += item.quantity;
        }
        return itemCount;
    }
}

export const cart = new Cart();
cart.reload().catch((event: unknown | null) => {
    if (event instanceof Error) {
        // this.$log.error(event.message);
    }
});
